// @flow
import React from 'react';
import { isBrowser } from 'react-device-detect';
import Button from 'components/common/Button';
import './SettingsEtc.scss';

type Props = {
  onAskUnregister: () => void,
};

const SettingsEtc = ({ onAskUnregister }: Props) => (
  <div className="SettingsEtc">
    <section>
      <Button theme="outline" color="gray" onClick={onAskUnregister} desktop={isBrowser}>
        탈퇴하기
      </Button>
    </section>
  </div>
);

export default SettingsEtc;



// WEBPACK FOOTER //
// ./src/components/settings/SettingsEtc/SettingsEtc.js